// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39Yca","top":"styles_top__1xge3"};